// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"cdee3b65","160":"3c8b86e5","208":"fd70bd3d","293":"2f715c4e","516":"7d374da9","519":"18474a60","840":"6bfadcf7","917":"2fb038a8","946":"2a6c4eb8"}[chunkId] + ".chunk.js";
};